module.exports = __webpack_public_path__ + "assets/owl-carousel.581fe948.svg";